const ClassicBridge = {
    getTasksForTaskList(params) {
        return window.ClassicBridge.getTasksForTaskList(params)
    },

    getTaskCustomFieldsList() {
        return window.ClassicBridge.getTaskCustomFieldsList()
    },

    patchTaskCustomField(id, fieldName, value) {
        return window.ClassicBridge.patchTaskCustomField(id, fieldName, value)
    },

    patchTask(id, patch) {
        return window.ClassicBridge.patchTask(id, patch)
    },

    /**
     * Returns object with setProps method
     * @param el
     * @returns {*}
     */
    integrateTaskPanelDetails(el) {
        return window.ClassicBridge.integrateTaskPanelDetails(el)
    },

    integrateInputWithSuggestions(el, props, fieldId) {
        return window.ClassicBridge.integrateInputWithSuggestions(el, props, fieldId)
    },

    integrateCsvUserImportModal(el) {
        return window.ClassicBridge.integrateCsvUserImportModal(el)
    },

    /**
     * Waiting while actual data will by synced from classic. For example, waiting after task creation
     * @returns {*}
     */
    syncChangesFromClassic() {
        return window.ClassicBridge.syncChangesFromClassic()
    }
}

/**
 *
 * @param taskId
 * @param retryIfNoData - retry request while data will not available or attempts will end
 * Usually chains of request performed:
 * -> POST to classic data modifications
 * -> /sync-data-from-classic - waiting while data was synced {@see ClassicBridge#syncChangesFromClassic}
 * -> GET data from next
 * But sometimes due https://jira.actimind.com/browse/AT-7569 data is not synced after `sync-data-from-classic`
 * Retry reading allow to retrieve data with small delay
 * @returns {Promise<unknown>}
 */
ClassicBridge.getTask = (taskId, retryIfNoData = false) => {
    const timesToRepeat = retryIfNoData ? 10 : 1
    let nRepeats = 0
    const msBetweenRepeat = 500
    const recCall = (resolve, reject) => {
        ClassicBridge.getTasksForTaskList({taskIds: [taskId]}).then((result) => {
            const task = result.items[0]
            if (task) {
                resolve(task)
            } else {
                if (++nRepeats >= timesToRepeat) {
                    reject(`task not fetching in ${timesToRepeat} repeats`)
                } else {
                    setTimeout(() => recCall(resolve, reject), msBetweenRepeat)
                }
            }
        })
    }
    return new Promise(recCall)
}

export default ClassicBridge



// WEBPACK FOOTER //
// ./web/js/next/ClassicBridge.js